"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyLeaseAPIService = exports.APIAuthService = exports.APIService = exports.CMSAPIService = void 0;
const axios_1 = __importDefault(require("axios"));
const qs_1 = __importDefault(require("qs"));
const LocalStorageService_1 = require("./LocalStorageService");
const base_ui_utils_token_1 = require("@motorata/base-ui.utils.token");
let API_URL = "https://api-eu.motorata.pl/api";
if (typeof process !== "undefined") {
    if (process.env.NEXT_PUBLIC_API_URL) {
        API_URL = process.env.NEXT_PUBLIC_API_URL;
    }
    else if (process.env.REACT_APP_API_URL) {
        API_URL = process.env.REACT_APP_API_URL;
    }
}
const CMS_URL = "http://motorata.adamwolny.pl/wp-json/wp/v2/";
const MYLEASE_URL = "https://us-central1-mylease-pl.cloudfunctions.net";
exports.CMSAPIService = axios_1.default.create({
    baseURL: CMS_URL,
    headers: {
        "Content-Type": "application/json",
    },
});
exports.CMSAPIService.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    config.baseURL = CMS_URL;
    return config;
}), error => {
    console.log(error.data);
    // eslint-disable-next-line no-undef
    Promise.reject(error);
});
exports.CMSAPIService.interceptors.response.use(
// @ts-ignore
(response) => __awaiter(void 0, void 0, void 0, function* () {
    return {
        items: response.data,
        totalPages: response.headers["x-wp-totalpages"],
    };
}), (error) => __awaiter(void 0, void 0, void 0, function* () {
    // eslint-disable-next-line no-undef
    return Promise.reject(error);
}));
exports.APIService = axios_1.default.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
    paramsSerializer: params => {
        return qs_1.default.stringify(params, {
            arrayFormat: "brackets",
        });
    },
});
exports.APIService.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    config.baseURL = API_URL;
    config.baseURL = API_URL;
    return config;
}), error => {
    console.log(error.data);
    // eslint-disable-next-line no-undef
    Promise.reject(error);
});
exports.APIService.interceptors.response.use((response) => __awaiter(void 0, void 0, void 0, function* () {
    return response.data;
}), (error) => __awaiter(void 0, void 0, void 0, function* () {
    // eslint-disable-next-line no-undef
    return Promise.reject(error);
}));
exports.APIAuthService = axios_1.default.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
    paramsSerializer: params => {
        return qs_1.default.stringify(params, {
            arrayFormat: "brackets",
        });
    },
});
exports.APIAuthService.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    const token = yield LocalStorageService_1.LocalStorageService.getObject("token");
    config.baseURL = API_URL;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    if (config.url.includes(":userId") && token) {
        const id = (0, base_ui_utils_token_1.getUserIdFromJWT)(token);
        config.url = config.url.replace(":userId", id);
    }
    if (config.url.includes(":profileId")) {
        const profileId = yield LocalStorageService_1.LocalStorageService.getObject("profileId");
        if (profileId) {
            config.url = config.url.replace(":profileId", profileId);
        }
    }
    return config;
}), error => {
    console.log(error.data);
    // eslint-disable-next-line no-undef
    Promise.reject(error);
});
exports.APIAuthService.interceptors.response.use((response) => __awaiter(void 0, void 0, void 0, function* () {
    return response.data;
}), (error) => __awaiter(void 0, void 0, void 0, function* () {
    // eslint-disable-next-line no-undef
    return Promise.reject(error);
}));
exports.MyLeaseAPIService = axios_1.default.create({
    baseURL: MYLEASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    paramsSerializer: (params) => {
        return qs_1.default.stringify(params, {
            arrayFormat: "brackets",
        });
    },
});
exports.MyLeaseAPIService.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    config.baseURL = MYLEASE_URL;
    config.baseURL = MYLEASE_URL;
    return config;
}), error => {
    console.log(error.data);
    // eslint-disable-next-line no-undef
    Promise.reject(error);
});
exports.MyLeaseAPIService.interceptors.response.use((response) => __awaiter(void 0, void 0, void 0, function* () {
    return response.data;
}), (error) => __awaiter(void 0, void 0, void 0, function* () {
    // eslint-disable-next-line no-undef
    return Promise.reject(error);
}));
//# sourceMappingURL=APIService.js.map